module.exports = __webpack_public_path__ + "media/images/childcare/card-mobile@3x-7b803cc78928bb753a4bde8cb6fbb41f.jpg";